import type {TurnItem, UserMessageItem} from '../../types/events'
import {TOOL_NAMES} from '../../constants/tool-names'
import {isInjectedSource} from '../command-helpers'
import {isDeniedResult} from './permission-constants'

// Tool names that ToolRenderer returns null for — they are rendered via
// dedicated UI (prompts, loading indicator, subagent groups) or are invisible.
const HIDDEN_TOOL_NAMES = new Set<string>([
  TOOL_NAMES.REPORT_INTENT,
  TOOL_NAMES.TASK,
  'ask_user',
  'exit_plan_mode',
  'permission_request',
])

/**
 * Whether a UserMessageItem would produce visible rendered output.
 * Mirrors the null-return checks in UserMessage.tsx.
 */
export function isUserMessageVisible(msg: UserMessageItem): boolean {
  if (msg.isDismissed) return false
  if (isInjectedSource(msg.source)) return false
  if (!msg.content?.trim()) return false
  return true
}

/**
 * Whether a TurnItem would produce visible rendered output.
 * Mirrors the null-return checks in each item renderer so the model can determine
 * visibility without rendering.
 */
export function isTurnItemVisible(item: TurnItem): boolean {
  switch (item.kind) {
    case 'assistant_text':
    case 'subagent_group':
      return true

    case 'tool_call':
      return !HIDDEN_TOOL_NAMES.has(item.toolCall.toolName)

    case 'permission':
      // Only denied permissions render; approved/pending render null
      if (!item.completedEvent) return false
      return isDeniedResult(item.completedEvent.data.result?.kind)

    case 'ask_user':
    case 'elicitation':
    case 'plan_approval':
      return item.completedEvent !== null

    case 'remote_steerable':
      return item.enabled

    default:
      return false
  }
}
